import PropTypes from 'prop-types'
import LinkButton from '../ui/LinkButton'
import './AsistenteFlechas.css'

const AsistenteFlechas = ({ clickPasoAnterior, clickPasoSiguiente, limiteInferior }) => {
  return (
    <>
      <LinkButton onClick={clickPasoAnterior} className="btn flechaArriba">
        <i className="fa fa-arrow-up fa-2x f-ebm-green" aria-hidden="true" />
      </LinkButton>
      <br />
      <br />
      {!limiteInferior && (
        <LinkButton onClick={clickPasoSiguiente} className="btn flechaAbajo">
          <i className="fa fa-arrow-down fa-2x f-ebm-green" aria-hidden="true" />
        </LinkButton>
      )}
    </>
  )
}

AsistenteFlechas.propTypes = {
  clickPasoAnterior: PropTypes.func.isRequired,
  clickPasoSiguiente: PropTypes.func.isRequired,
  limiteInferior: PropTypes.bool
}

export default AsistenteFlechas
